import React from "react";

const IconLocation = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="13" r="5" stroke="#00c896" strokeWidth="1.8" fill="rgba(0,200,150,0.08)"/>
    <path d="M16 4C10.477 4 6 8.477 6 14c0 7 10 16 10 16s10-9 10-16c0-5.523-4.477-10-10-10z" stroke="#00c896" strokeWidth="1.8" fill="rgba(0,200,150,0.06)"/>
  </svg>
);

const IconEmail = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="4" y="8" width="24" height="16" rx="3" stroke="#00c896" strokeWidth="1.8" fill="rgba(0,200,150,0.06)"/>
    <path d="M4 11l12 8 12-8" stroke="#00c896" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IconPhone = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M10 5h4l2 5-2.5 1.5a14 14 0 007 7L22 16l5 2v4a2 2 0 01-2 2C11 24 8 11 8 7a2 2 0 012-2z" stroke="#00c896" strokeWidth="1.8" strokeLinejoin="round" fill="rgba(0,200,150,0.06)"/>
  </svg>
);

const contactCards = [
  {
    icon: <IconLocation />,
    label: "Headquarters",
    title: "Jakarta, Indonesia",
    lines: ["Menara Sentraya, Lantai 18", "Jl. Iskandarsyah Raya No. 1A", "Kebayoran Baru, Jakarta Selatan 12160"],
    action: null,
  },
  {
    icon: <IconEmail />,
    label: "Email Us",
    title: "Get in Touch",
    lines: ["hello@trustengine.co.id", "sales@trustengine.co.id", "support@trustengine.co.id"],
    action: "mailto:hello@trustengine.co.id",
  },
  {
    icon: <IconPhone />,
    label: "Call Us",
    title: "Sales & Support",
    lines: ["+62 21 5000 1234", "Mon – Fri, 09:00 – 18:00 WIB", "Enterprise: 24/7 on-call"],
    action: "tel:+622150001234",
  },
];

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-80">
      <div className="container">
        <div className="row mt-none-30">
          {contactCards.map((card, i) => (
            <div className="col-lg-4 col-md-6 mt-30" key={i}>
              <div style={{
                background: "#ffffff",
                border: "1px solid rgba(15,32,64,0.08)",
                borderRadius: 14,
                padding: "36px 32px",
                boxShadow: "0 4px 24px rgba(15,32,64,0.06)",
                height: "100%",
              }}>
                {/* Icon */}
                <div style={{
                  width: 64, height: 64, borderRadius: 14,
                  background: "rgba(0,200,150,0.08)",
                  border: "1.5px solid rgba(0,200,150,0.2)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 20,
                }}>
                  {card.icon}
                </div>

                <div style={{ fontSize: 11, fontWeight: 700, color: "#00c896", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>
                  {card.label}
                </div>
                <h4 style={{ color: "#0f2040", fontWeight: 700, fontSize: 20, marginBottom: 14 }}>
                  {card.title}
                </h4>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  {card.lines.map((line, j) => (
                    <span key={j} style={{ color: "rgba(15,32,64,0.6)", fontSize: 14 }}>{line}</span>
                  ))}
                </div>
                {card.action && (
                  <a
                    href={card.action}
                    style={{
                      display: "inline-block", marginTop: 20,
                      background: "rgba(0,200,150,0.08)",
                      border: "1px solid rgba(0,200,150,0.3)",
                      color: "#00a07a", borderRadius: 20,
                      padding: "6px 18px", fontSize: 13, fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    Contact →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
